import React, { Component, Fragment } from "react";
import Select from "react-select";
import { NavLink } from "react-router-dom";
import AppContext from "../../../contexts/AppContext";
import NoData from "../../utilities/NoData";
import LoadingData from "../../utilities/LoadingData";
import { apply } from "../../../services/userBadge";
import { badgeRecords, allBadgeRecords, record, search } from "../../../services/userBadge";
import Header from "../account/Header";
import AccountNav from "../account/AccountNav";
import BadgesList from "./BadgeList";


class WriterBadges extends Component {
    state = {
        items: [],       
        meta: {},
        query: "",
        search: false,
        loading: true,
        tableCount: "hide",
        filterItem: "all",
        filterItemName: "All Achievements",
        filterList:[],
        showClear: false,
    };

    toggleTableCount = () => {
        this.setState({
            tableCount: this.state.tableCount === "hide" ? "show" : "hide"
        });
    };
    
    record = id => {
        return record(id);
    };
    onQueryChange = field => {
        this.setState({ query: field.target.value, showClear: field.target.value.length > 0 ? true : false });        
    };
    
    onFilterChange = selectedOption => {
        this.setState({ filterItem: selectedOption.value, filterItemName: selectedOption.name });
        this.getBadges(selectedOption.value);
    };
    search = query => {       
        this.setState({ loading: true });
        search(query).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                search: true,
                query: query,
                loading: false,
                showClear: true
            });
        });
    };

    

    clear = () => {
        this.setState({ loading: true });
        this.getBadges(this.state.filterItem);
    };
    hideClear = () => {
        this.setState({ query: '', showClear: false });
        this.clear();
    }

    getBadges(type)
    {
        this.setState({ loading: true });
        badgeRecords(type)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    search: false,
                    loading: false
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                this.context.state.handelError(error);
            });
    }

    componentDidMount() {    
        
            this.getBadges(this.state.filterItem);

            this.setState({ filterList: [
                {"id":'all',"value":'all',"name":'All Achievements',"label":'All Achievements'},               
                {"id":'performance',"value":'performance',"name":'Performance',"label":'Performance'},
                {"id":'experience',"value":'experience',"name":'Experience',"label":'Experience'},
                {"id":'eraned_badges',"value":'eraned_badges',"name":'I have earned',"label":'I have earned'},
                {"id":'not_eraned_badges',"value":'not_eraned_badges',"name":'I have not earned',"label":'I have not earned'}, 
            ] }); 
    }
    changePage = page => {
        if (this.state.search === true) {
            search(this.state.query, page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        } else {
            allBadgeRecords(page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        }
    };
    submitSearch = e => {
        e.preventDefault();
        if (this.state.query.length >= 1) {            
            this.search(this.state.query);
        } else{
            this.clear();
        }
    };
    apply = (id, data) => {
        return apply({
            badge_id: id,
            form_data: data
        })
            .then(response => {
                let temp = this.state.items;
                for (var i in temp) {
                    if (temp[i].id === id) {
                        temp[i] = response.data;
                        this.setState({ items: temp });
                    }
                }
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };
    
    render() {
        let performance_badges = this.state.items.filter( function (badge) {
            return badge.badge_type === 'performance';
        });
    
        let experience_badges = this.state.items.filter( function (badge) {
            return badge.badge_type === 'experience';
        });
        return (
            <Fragment>
                    <Header></Header>
                	{/* <section className="dashboard-nav">
		                <div className="container">
		            	    <div className="head">
		            		    <h1>Achievements</h1>
		            		</div>		            		
		            		<AccountNav></AccountNav>
		            	</div>
		            </section> */}
					<section className="achivements portfolioDetails_v2 pt-md-15 pb-md-40 pb-20 pt-20 mt-4">
						<div className="container writer-container">                            
                            <div className="achivement-form" >
							    <div className="row justify-content-between mb-5 pb-4">
							        <div className="col-md-4 col-sm-6 mb-sm-0 mb-4">
							    	    {/* <input type="search" id="badge-search" className="form-control rounded-pill pl-4 pr-2" placeholder="Search achivements" value={this.state.query} onChange={this.onQueryChange.bind(this)}/> */}
                                        <form
                                            onSubmit={this.submitSearch}
                                            className="row align-items-center"
                                        >   <div className="form-group">
                                                <input
                                                    onChange={this.onQueryChange.bind(this)}
                                                    value={this.state.query}
                                                    type="search"
                                                    className="form-control rounded-pill pl-4 pr-2"
                                                    placeholder="Search Achievements"
                                                ></input>
                                                {this.state.showClear ? <span onClick={this.hideClear}><i className="fe fe-x"></i></span> : ''}
											</div>	
                                        </form>
                                        
                                    </div>
							    	<div className="col-md-3 col-sm-5">
									    <div className="select-container">
                                        <Select 
                                                styles={{
                                                    control: base => ({
                                                        ...base,
                                                        "&:hover": {
                                                            borderColor:
                                                                "#1cd2ad",
                                                            boxShadow: "none"
                                                        },
                                                        "&": {
                                                            borderColor:
                                                                "#d2ddec",
                                                            boxShadow: "none"
                                                        }
                                                    }),
                                                    dropdownIndicator: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    }),
                                                    singleValue: base => ({
                                                        ...base,
                                                        color: "inherit"
                                                    })
                                                }}
                                                name="badge_filter"
                                                id="badge_filter" 
                                                value={this.state.filterItem}   
                                                placeholder = {this.state.filterItemName}                                            
                                                onChange={
                                                    this
                                                        .onFilterChange
                                                }                                              
                                                options={
                                                    this.state.filterList
                                                }
                                            ></Select>
										    
										</div>
							    	</div>
							    </div>
                            </div>							
							<div className="row">
								<div className="col-12">
                                    <h3 className="badge-title mb-5">
                                        Performance Badges
                                    </h3>
                                    <div className="badges-list">
                                        {this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : performance_badges.length >= 1 ? (
                                            <ul>
                                                
                                                {performance_badges.map(
                                                        (item, index) => {
                                                            return (
                                                                <BadgesList                                                                   
                                                                    
                                                                    item={item}
                                                                    index={
                                                                        index
                                                                    }
                                                                    key={index}
                                                                ></BadgesList>
                                                            );
                                                        }
                                                    )}

                                            </ul>
                                        ) : (
                                            <NoData></NoData>
                                        )}
                                    </div>                                   
								</div>
								<div className="col-12 mt-5">
                                    <h3 className="badge-title mb-5">
                                        Experience Badges
                                    </h3>
                                    <div className={this.context.state.user.plan_id === 1 ? "subscribe badges-list" : "badges-list"}>
                                        {this.state.loading === true ? (
                                            <LoadingData></LoadingData>
                                        ) : experience_badges.length >= 1 ? (
                                            <ul>                                               

                                                    {experience_badges.map(
                                                        (item, index) => {
                                                            return (
                                                                <BadgesList                                                                   
                                                                    
                                                                    item={item}
                                                                    index={
                                                                        index
                                                                    }
                                                                    key={index}
                                                                ></BadgesList>
                                                            );
                                                        }
                                                    )}
                                            </ul>
                                        ) : (
                                            <NoData></NoData>
                                        )}
										{this.context.state.user.plan_id === 1 ? 
                                            <div className="subscribe-modal">
                                                <img src="/images/plus_white.png" alt="ProWriter-Plus"/>
                                            	<h3>Upgrade your account</h3>
                                            	<p>Become a ProWriter Plus member today to unlock all Achievements.</p>
                                            	<NavLink
                                                    className="btn btn-primary"
                                                    to={`/account/settings/membership`}
													exact={true}
                                                >
                                                    Get ProWriter Plus
                                                </NavLink>
                                            </div>
                                        : ""}
                                    </div>                                    
								</div>
							</div>
                                        
                        </div>
					</section>
            </Fragment>
        );
    }
}
WriterBadges.contextType = AppContext;
export default WriterBadges;



// WEBPACK FOOTER //
// ./src/components/writer/writerBadges/WriterBadges.js